import { Route, Routes } from "react-router-dom"
import Login from "../components/Login";
import Home from "../components/Home/Home";
import Partition from "../components/Partition/Partition";
import Users from "../components/Users/Users";
import KpiCriteria from "../sections/KpiCriteria";
import KpiDetailWrapper from "../sections/KpiDetailWrapper";
import Layout from "../sections/Layout";
import KafedraTeachers from "../sections/KafedraTeachers";
import Kafedralar from "../sections/Kafedralar";
import KafedraPointDistribution from "../sections/KafedraPointDistribution";
import RequirementsByParameter from "../sections/RequirementsByParameter";
import TeachersWithPoints from "../sections/TeachersWithPoints";
import TeachersWithPointsRange from "../sections/TeachersWithPointsRange";
import TeachersByCategoryRanking from "../sections/TeachersByCategoryRanking";
import WelcomePage from "../components/Home/WelcomePage";
import ProRectorDrillDown from "../components/ProRector/ProRectorDrillDown";
import ProRectorTeacherApps from "../components/ProRector/ProRectorTeacherApps";

const Routers = () => {
    return (
        <Routes>
            <Route path='/login' element={<Login />} />
            <Route path='/' element={<WelcomePage />} />
            <Route path='/home' element={<Home />} />
            <Route path='/dashboard/drill-down' element={<ProRectorDrillDown />} />
            <Route path='/dashboard/teacher-applications/:teacherId' element={<ProRectorTeacherApps />} />
            <Route path='/partitions' element={<Partition />} />
            <Route path='/users' element={<Users />} />
            <Route path='/kpi' element={<KpiCriteria />} />
            <Route path='/kpi/:id' element={<KpiDetailWrapper />} />
            <Route path='/kafedralar' element={<Kafedralar />} />
            <Route path='/kafedra/:id/teachers' element={<KafedraTeachers />} />
            <Route path='/kafedra-distribution/:id' element={<KafedraPointDistribution />} />
            <Route path='/requirements-by-parameter/:id' element={<RequirementsByParameter />} />
            <Route path='/teachers-with-points' element={<TeachersWithPoints />} />
            <Route path='/teachers-with-points-range/:range' element={<TeachersWithPointsRange />} />
            <Route path='/teachers-by-category/:category' element={<TeachersByCategoryRanking />} />
            <Route path='*' element={<><h1 style={{ margin: '50px 0px', textAlign: 'center', fontSize: 50 }}>404</h1></>} />
        </Routes>
    )
}
export default Routers;